import React from 'react';

import Responsive from '@/components/Responsive';

import SurveyCompleteContentDesktop from './index.desktop';
import SurveyCompleteContentMobile from './index.mobile';
import { SurveyCompleteContentProps } from './types';

const SurveyCompleteContent: React.FC<SurveyCompleteContentProps> = (props) => {
  return (
    <Responsive>
      <Responsive.Default>
        <SurveyCompleteContentDesktop {...props} />
      </Responsive.Default>
      <Responsive.Mobile>
        <SurveyCompleteContentMobile {...props} />
      </Responsive.Mobile>
    </Responsive>
  );
};

export default React.memo(SurveyCompleteContent);
